//
import GCommuneModel from '@/models/General/GCommune'

//
export default [
  {
    name: 'name',
    type: 'text-field',
    props: {
      label: 'Nombre',
    },
  },
  {
    name: 'address',
    type: 'text-field',
    props: {
      label: 'Dirección',
    },
  },
  {
    name: 'g_commune_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'name',
      itemValue: 'id',
      label: 'Comuna',
      model: GCommuneModel,
      noAsyncSearch: true,
      noDataText: 'Sin comunas.',
      noObject: true,
      paramSearch: 'name',
    },
  },
  {
    name: 'phone',
    type: 'text-field',
    props: {
      label: 'Teléfono',
    },
  },
  {
    name: 'email',
    type: 'text-field',
    props: {
      label: 'Correo electrónico',
    },
  },
  {
    name: 'branch_office_sii',
    type: 'text-field',
    props: {
      label: 'Codigo en SII.',
    },
  },
]
